module.exports = __webpack_public_path__ + "img/football.43009ebb.png";